
import { CreditCard, EventNote, LocationPin, PaidOutlined, Person, PersonOutline, StickyNote2Outlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material';
import { get, map, round } from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { setBookingStep, setCart, setDataByStep } from '../../Actions';
import 'add-to-calendar-button';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { useState } from 'react';
import { EMAILREGEX } from '../../Assets/constants';
import { saveEmail } from '../../Helpers';

function Confirmation(props) {
    const hasTotalAmount = Number(get(props, "3.total", 0)) > 0;
    const paymentRequired = get(props, "2.payment_required", false) && hasTotalAmount;
    const date = get(props, "3.date", "");
    const timesBySlot = get(props, "3.timesBySlot", []);
    const { setDataByStep, setBookingStep, setCart, setAlert } = props;
    const provider_notes = get(props, "4.provider_notes", "");
    const [email, setEmail] = useState("");
    const [validEmail, setValidEmail] = useState(false);
    const location_name = get(props, "1.location.name", "") ? get(props, "1.location.name", "") : get(props, "3.location_name", "");
    const room_number = get(props, "3.room_number", "") ? get(props, "3.room_number", "") : "";

    const submitEmail = () => {
        saveEmail({
            email,
            slot_ids: get(props, "3.slot_ids", []),
        }, (_response) => {
            setEmail("");
            setValidEmail(false);
            setAlert("success", "Email saved successfully")
        }, (err) => {
            setAlert("error", "Error saving email")
        })
    }

    const saveConfirmationView = () => {
        // if (paymentRequired) {
            return null;
        // }
        return (<div className='txt-align-left mb-32'>
            <div className='contentPrimary font-weight-bold size-24-32 sm-size-28-36 mb-16 sm-mb-8'>
                Save your Confirmation
            </div>
            <div className='row'>
                <div className={`col-12 col-sm-8`}>
                    <div className={`form-group mb-16`}>
                        <label htmlFor="email" className="mb-8 font-weight-bold size-16-20">Email</label>
                        <input type="email" id="email" className="form-control generic-input-style" aria-describedby="emailHelp" placeholder="Enter email"
                            value={email} onChange={(event) => {
                                setEmail(event.target.value)
                                setValidEmail(EMAILREGEX.test(event.target.value))
                            }}
                        />
                        <small id="emailHelp" className="form-text size-14-20 contentTertiary">This is where we'll send your confirmation details.</small>
                    </div>
                </div>

                <div className={`col-12 col-sm-4`}>
                    <button
                        type="button"
                        className="btn cta-primary p-16-20-imp mt-24"
                        onClick={(e) => {
                            e?.preventDefault();
                            if (!email || !validEmail) {
                                setAlert("error", "Please enter a valid email")
                                return;
                            }
                            submitEmail();
                        }}
                    >
                        Submit
                    </button>
                </div>
            </div>

        </div>)
    }

    const saveToCalendarView = () => {
        return (<>
            <div className='txt-align-left contentPrimary font-weight-bold size-24-32 sm-size-28-36 mb-16 sm-mb-8'>
                Save to Calendar
            </div>
            <div className='size-16-20 font-weight-bold mb-12'>
                <AddToCalendarButton
                    name={`Soothe session with ${get(props, "3.provider_name", "") || "Provider TBD"}`}
                    startDate={date}
                    startTime={moment(`${date} ${get(timesBySlot, "0.start_time", "")}`, "YYYY-MM-DD h:mm A").format("HH:mm")}
                    endDate={date}
                    endTime={moment(`${date} ${get(timesBySlot, "0.end_time", "")}`, "YYYY-MM-DD h:mm A").format("HH:mm")}
                    options="'Apple','Google','Outlook.com'"
                    buttonsList
                    size="5"
                    location={'' + location_name + ' ' + room_number}
                ></AddToCalendarButton>
            </div>
        </>);
    }
    return (<>
        <div className='size-44-52 contentPrimary font-weight-bold mb-16'>
            Booking confirmed!
        </div>
        <div className=' txt-align-left'>
            <MenuList className='mb-24' PaperProps={{
                elevation: 0, // This removes the shadow
                sx: {
                    boxShadow: 'none', // Optional, ensure no residual shadow
                    zIndex: 10,
                }
            }}>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <PersonOutline fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Guest</span>}
                        secondary={`${get(props, "4.first_name", "")} ${get(props, "4.last_name", "")}`}
                    />
                </MenuItem>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <EventNote fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Date</span>}
                        secondary={moment(date, "YYYY-MM-DD").format("ddd, MMM D") + ", " + map(timesBySlot, item => `${item.start_time}-${item.end_time}`).join(', ')}
                    />
                </MenuItem>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <LocationPin fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Location</span>}
                        secondary={location_name + " " + room_number}
                    />
                </MenuItem>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <Person fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Provider</span>}
                        secondary={get(props, "3.provider_name", "") || "Provider TBD"}
                    />
                </MenuItem>
                <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <PaidOutlined fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='br-b-opaque pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Total</span>}
                        secondary={`$${round(get(props, "3.total", 0), 2).toFixed(2)}`}
                    />
                </MenuItem>
                {paymentRequired ? <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <CreditCard fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className={`pb-16 mb-neg-16 ${provider_notes ? "br-b-opaque" : ""}`}
                        primary={<span className='mb-4'>Payment Method</span>}
                        secondary={<>
                            {get(props, "4.credit_card.brand")} ending in {get(props, "4.credit_card.last_4", "")}
                            <br />
                            Exp. {get(props, "4.credit_card.exp_month", "")}/{get(props, "4.credit_card.exp_year", "")}
                        </>}
                    />
                </MenuItem> : null}
                {provider_notes ? <MenuItem className='pb-0-imp'>
                    <ListItemIcon>
                        <StickyNote2Outlined fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className='pb-16 mb-neg-16'
                        primary={<span className='mb-4'>Note to Provider</span>}
                        secondary={provider_notes}
                    />
                </MenuItem> : null}
            </MenuList>
        </div>
        <div className='size-18-28 contentPrimary mt-32 sm-mt-16 mb-32 sm-mb-16'>
            Please arrive at least 5 minutes before your start time
        </div>
        {saveConfirmationView()}
        {saveToCalendarView()}
    </>);
}
const mapStateToProps = (state) => ({
    ...state.booking
});
export default connect(mapStateToProps, {
    setBookingStep, setDataByStep, setCart
})(Confirmation);